























import { Component, Mixins } from 'vue-property-decorator';
import Icon from '../../../generic/Icon.vue';
import GenericInput from '../../../generic/forms/Input.vue';
import LoginMixin from '../abstracts/LoginMixin';
import { GitHubGateway } from 'ganttlab-gateways';
import { Credentials } from 'ganttlab-entities';

@Component({
  components: {
    Icon,
    GenericInput,
  },
})
export default class Login extends Mixins(LoginMixin) {
  // implementing abstract defaultCredentials with appropriate structure
  public defaultCredentials: Credentials = {
    token: '',
  };

  // implementing abstract getSourceGateway
  getSourceGateway() {
    return new GitHubGateway();
  }

  // from there, this logic is totally specific to the GitHub Login vue
}
